(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-list-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const pillButtons = document.querySelectorAll('.pillbox-button');
    const tabPanels = document.querySelectorAll('.tab-panel');

    pillButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const targetId = this.dataset.target;

        // Remove active class from all buttons and panels
        pillButtons.forEach((btn) => btn.classList.remove('active'));
        tabPanels.forEach((panel) => panel.classList.remove('active'));

        // Add active class to clicked button and corresponding panel
        this.classList.add('active');
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
          targetPanel.classList.add('active');
          targetPanel.removeAttribute('hidden');
        }

        // Hide other panels
        tabPanels.forEach((panel) => {
          if (panel.id !== targetId) {
            panel.setAttribute('hidden', '');
          }
        });
      });

      // Keyboard navigation
      button.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
